import React from 'react';
import { Link } from 'react-router-dom';

const Security: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <section className="pt-24 pb-12 bg-gradient-to-br from-indigo-50 via-white to-blue-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Security</h1>
          <p className="text-gray-600 max-w-3xl">
            We take security seriously. CosmaComply uses industry-standard encryption (in transit and at rest),
            role-based access control, and audit logging. Data retention follows MoCRA requirements for adverse events.
          </p>

          <div className="grid md:grid-cols-2 gap-6 mt-8">
            <div className="bg-white border border-gray-200 rounded-lg p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Encryption</h3>
              <ul className="list-disc pl-5 text-gray-600 text-sm space-y-1">
                <li>TLS for data in transit</li>
                <li>Encrypted storage for sensitive data</li>
              </ul>
            </div>
            <div className="bg-white border border-gray-200 rounded-lg p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Access Controls</h3>
              <ul className="list-disc pl-5 text-gray-600 text-sm space-y-1">
                <li>Role-based permissions</li>
                <li>Audit logging for key actions</li>
              </ul>
            </div>
          </div>

          <p className="text-xs text-gray-500 mt-8">
            CosmaComply is not affiliated with or approved by the FDA. See the{' '}
            <Link to="/disclaimer" className="text-indigo-600 hover:underline">Disclaimer & Security</Link> page for details.
          </p>
        </div>
      </section>
    </div>
  );
};

export default Security;
